import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Network } from '@ionic-native/network';
import moment from 'moment';
import { LoadingController, Platform, AlertController } from 'ionic-angular';

@Injectable()
export class LivedataProvider {
  versionUrl: string = 'https://www.montereyboats.com/zupload/model-app-version.json';
  apiUrl: string = 'https://www.montereyboats.com/zupload/model-app-data.json';
  needUpdate: boolean = true;
  loading: any;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    private network: Network,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    private alertCtrl: AlertController) { }

  isConnected(): boolean {
    let conntype = this.network.type;
    return conntype && conntype !== 'unknown' && conntype !== 'none';
  }

  getData() {
    return new Promise(resolve => {
      this.storage.get('formattedData').then((formattedData) => {
        // formattedData.lastUpdated = moment().subtract(2, 'days'); // Dev mode make lastupdated 2 days ago
        if (!formattedData || typeof formattedData == undefined) {
          console.log("No lastUpdated get live data");
          this.getLiveData().then((result: any) => {
            resolve(result);
          });
        } else if (moment().diff(moment(formattedData.lastUpdated), 'h')) {
          console.log("has been over 24 hours since update");
          this.getLiveData().then((result: any) => {
            resolve(result);
          });
        } else {
          console.log("has lastUpdated less than 24 hours old");
          this.storage.get('formattedData').then((data) => {
            if (!data || typeof data == undefined) {
              console.log("no data? get live data");
              this.getLiveData().then((result: any) => {
                resolve(result);
              });
            } else {
              // console.log("has data resolve");
              resolve(data);
            }
          });
        }
      });
    });
  }

  checkHash() {
    return new Promise(resolve => {
      this.storage.get('dataHash').then((storedHash) => {
        // console.log(storedHash);
        if (!storedHash || typeof storedHash == undefined) {
          // no hash. get hash then live data
          this.http.get(this.versionUrl).subscribe((liveHash: any) => {
            if (!liveHash || typeof liveHash == undefined) {
              this.presentAlert("Connection Problem", "There was a problem getting data and no stored data availabel. Please check your network connection and try again.");
              resolve(false);
            } else {
              // console.log('updated hash');
              this.storage.set('dataHash', liveHash);
              // get live data
              resolve(true);
            }
          });
        } else {
          // we have a hash, check if data has changed by comparing
          this.http.get(this.versionUrl).subscribe((liveHash: any) => {
            if (storedHash.hash == liveHash.hash) {
              // hash is the same resolve stored data
              console.log('hash same');
              resolve(false);
            } else {
              // hash different, update data
              console.log('hash different');
              resolve(true);
            }
          });
        }
      });
    });
  }

  getLiveData() {
    return new Promise(resolve => {
      this.presentLoading();
      let app = false;
      if (this.platform.is('cordova')) {
        app = true;
      } else {
        app = false;
      }
      if (app) {
        console.log("PhoneGap application");
        if (this.isConnected()) {
          console.log("network detected");
          if (this.checkHash()) {
            this.http.get(this.apiUrl).subscribe((result: any) => {
              let formattedData = {
                version: result.version,
                allData: result.models,
                lastUpdated: moment().toDate()
              };
              this.storage.set('formattedData', formattedData);
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(formattedData);
            }, err => {
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(err);
            });
          } else {
            this.storage.get('formattedData').then((data) => {
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(data);
            });
          }
        } else {
          this.storage.get('formattedData').then((data) => {
            if (!data || typeof data == undefined) {
              console.log('no internet');
              this.presentAlert("Connection Problem", "There was a problem getting data and no stored data availabel. Please check your network connection and try again.");
            } else {
              console.log('no internet using saved data');
              this.presentAlert("Connection Problem", "No internet connection detected. The app will use cached data until you connect to a network.");
              resolve(data);
            }
            if (this.loading) {
              this.loading.dismiss();
            }
          });
        }
      } else {
        console.log("Web page");
        if (navigator.onLine) {
          if (this.checkHash()) {
            this.http.get(this.apiUrl).subscribe((result: any) => {
              let formattedData = {
                version: result.version,
                allData: result.models,
                lastUpdated: moment().toDate()
              };
              this.storage.set('formattedData', formattedData);
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(formattedData);
            }, err => {
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(err);
            });
          } else {
            this.storage.get('formattedData').then((data) => {
              if (this.loading) {
                this.loading.dismiss();
              }
              resolve(data);
            });
          }
        } else {
          this.storage.get('formattedData').then((data) => {
            if (!data || typeof data == undefined) {
              console.log('no internet');
              this.presentAlert("Connection Problem", "There was a problem getting data and no stored data availabel. Please check your network connection and try again.");
            } else {
              console.log('no internet using saved data');
              this.presentAlert("Connection Problem", "No internet connection detected. The app will use cached data until you connect to a network.");
              resolve(data);
            }
            if (this.loading) {
              this.loading.dismiss();
            }
          });
        }
      }
    });
  }

  presentAlert(title, message) {
    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        }
      ]
    });
    alert.present();
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Getting Data...'
    });

    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/livedata/livedata.ts